import { path } from 'ramda';
import { IOfferState, IUserState } from '../../redux/reducers';
import { getLocationPath } from './getLocationPath';

/**
 *
 * @description Возвращает геолокацию объявления.
 * Если геолокация объявления не определена - возвращает геолокацию пользователя.
 */
export function getLocationPathWithUserGeoFallback(offer: IOfferState, user: IUserState): number[] {
  const userGeoId = path<number>(['geo', 'id'], user);
  const userLocationPath = userGeoId ? [userGeoId] : [];
  const offerLocationPath = getLocationPath(offer);
  const locationPath = offerLocationPath.length === 0 ? userLocationPath : offerLocationPath;

  return locationPath;
}
